module.exports = __webpack_public_path__ + "img/no-image-portal.66585b60.jpg";